<template>
  <edit-page
    :selectedNavItem="selectedNavItem"
    :toggleForm="toggleForm"
    @form-submited="submit()"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        dense
        label="Title"
        :rules="NoEmptyRule"
        filled
        required
        v-model="requestData.title"
      ></v-text-field>

      <v-text-field
        dense
        label="Abbreviation"
        :rules="NoEmptyRule"
        filled
        required
        v-model="requestData.abbreviation"
      ></v-text-field>

      <v-textarea
        dense
        label="Description"
        :rules="NoEmptyRule"
        filled
        rows="10"
        required
        v-model="requestData.description"
      ></v-textarea>
      <v-text-field
        dense
        label="ICD Code"
        filled
        v-model="requestData.icdCode"
      ></v-text-field>
      <v-checkbox
        v-model="requestData.hasUnitOfMeasurement"
        label="Has Unit Of Measurement"
      ></v-checkbox>
      <v-select
        v-if="requestData.hasUnitOfMeasurement"
        :items="unitOfMeasurementTypes"
        item-text="title"
        filled
        return-object
        @change="getUnitOfMeasurements()"
        v-model="requestData.SelectedUnitOfMeasurementType"
        :rules="[(v) => !!v || '*Required']"
        label="Unit Of Measurement Type"
      ></v-select>
      <v-select
        v-if="requestData.hasUnitOfMeasurement"
        :items="unitOfMeasurements"
        item-text="unitName"
        filled
        return-object
        v-model="requestData.SelectedUnitOfMeasurement"
        :rules="[(v) => !!v || '*Required']"
        label="Unit Of Measurement"
      ></v-select>
      <v-checkbox v-model="requestData.hasRange" label="Has Range"></v-checkbox>
      <v-checkbox
        v-model="requestData.hasAcceptedValue"
        label="Has Accepted Value"
      ></v-checkbox>
    </v-form>
  </edit-page>
</template>
<script>
import EditPage from "../EditPage.vue";
import apiClient from "../../API/apiClient";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { EditPage },
  name: "edit-",
  props: ["selectedNavItem", "toggleForm"],
  created() {
    console.log("getting unit of measurments");
    this.getUnitOfMeasurementTypes();
    this.requestData = this.selectedEditObject;
  },
  data() {
    return {
      valid: false,
      unitOfMeasurements: [],
      requestData: {
        title: "",
        abbreviation: "",
        description: "",
        HasRange: false,
        HasUnitOfMeasurement: false,
        HasAcceptedValue: false,
        SelectedInstitution: null,
        InstitutionId: null,
        SelectedUnitOfMeasurementType: null,
        UnitOfMeasurementId: null,
      },
      institutions: [],
      name: "",
      NoEmptyRule: [(v) => !!v || "*required"],
    };
  },
  methods: {
    ...mapActions(["getUnitOfMeasurementTypes"]),
    submit() {
      if (this.$refs.form.validate()) {
        this.requestData.InstitutionId = this.currentInstitution.id;
        if (this.requestData.hasUnitOfMeasurement) {
          this.requestData.UnitOfMeasurementId =
            this.requestData.SelectedUnitOfMeasurement.id;
        }

        apiClient
          .call(
            "PUT",
            "institutions/" +
              this.currentInstitution.id +
              "/tests/" +
              this.selectedEditObject.id,
            this.requestData
          )
          .then((response) => {
            console.log(response);
            this.toggleForm();
            this.$store.dispatch("getTests");
          })
          .catch((err) => console.log(err));
      }
    },
    getUnitOfMeasurements() {
      apiClient
        .call(
          "GET",
          "institutions/" +
            this.currentInstitution.id +
            "/unitOfMeasurementTypes/" +
            this.requestData.SelectedUnitOfMeasurementType.id +
            "/unitOfMeasurements",
          null
        )
        .then((response) => {
          this.unitOfMeasurements = response;
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    ...mapGetters([
      "currentInstitution",
      "unitOfMeasurementTypes",
      "selectedEditObject",
    ]),
  },
};
</script>